import clsx from 'clsx';
import { useLayoutEffect, useState } from 'react';
import { TabProps } from './models';
import { SecondarySidebarItem } from './SecondarySidebarItem';

export function SecondarySidebar<T>({
  tabs,
  forceExpanded = false,
  topSpacing = 7,
  expandThreshold = 1440
}: {
  tabs: TabProps<T>[];
  forceExpanded?: boolean;
  topSpacing?: number;
  expandThreshold?: number;
}) {
  const [expanded, setExpanded] = useState(false);

  useLayoutEffect(() => {
    const onResize = () => {
      if (forceExpanded) {
        setExpanded(true);
        return;
      }

      const screenWidth = document.body.getBoundingClientRect().width;
      if (screenWidth >= expandThreshold) {
        setExpanded(true);
      } else {
        setExpanded(false);
      }
    };

    onResize();

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <div className={`tab-nav-wrapper pt-${topSpacing}`}>
      <ul className={clsx('tab-nav tab-nav-vertical text-transform-none', expanded && 'expanded')}>
        {tabs
          .filter(tab => !tab.hidden)
          .map((tab, index) => (
            <li key={`tab-${index.toString()}`}>
              <SecondarySidebarItem tab={tab} expanded={expanded} />
            </li>
          ))}
      </ul>
    </div>
  );
}
